




























































import Vue from 'vue';
import Component from 'vue-class-component';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import LocationAutocomplete from '@/general/component/form/autocomplete/LocationAutocomplete.vue';
import PageContainer from '@/general/component/PageContainer.vue';
import { sensorApi } from '@/context/sensor/api/SensorApi';
import SensorRouter from '@/context/sensor/router/SensorRouter';
import { SensorFilter } from '@/context/sensor/model/SensorFilter';
import RadioGroup from '@/general/component/form/input/RadioGroup.vue';
import { Api } from '@/common/api/Api';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocompleteTS.vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import ColoredBooleanField from "@/general/component/ColoredBooleanField.vue";

@Component({
  components: {
    ColoredBooleanField,
    RadioGroup,
    PageContainer,
    LocationAutocomplete,
    ModelAutocomplete,
    CustomerAutocomplete,
    FacilityAutocomplete,
    DataLoggerAutocomplete,
    TextInput
  }
})
export default class SensorListContainer extends Vue {
  router: SensorRouter = new SensorRouter();
  filter: SensorFilter = new SensorFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Aktywny",
      value: "active",
      align: "left"
    },
    {
      text: "Wirtualny",
      value: "virtual",
      align: "left"
    },
    {
      text: "Obliczenie",
      value: "virtualCalculation",
      align: "left"
    },
    {
      text: "Obis",
      value: "obisNumber",
      align: "left"
    },
    {
      text: "Numer rejestru",
      value: "registerNumber",
      align: "left"
    },
    {
      text: "Mikroserwer",
      value: "dataLoggerIdentifier",
      align: "left"
    },
    {
      text: "Obiekt",
      value: "facilityStoreNumber",
      align: "left"
    },
    {
      text: "Klient",
      value: "clientName",
      align: "left"
    },
    {
      text: "Tag",
      value: "sensorTag",
      align: "left"
    }
  ];
  commonHeaders: Array<Record<string, unknown>> = [
    {
      text: "Id / Numer sensora",
      value: "id",
      align: "left"
    },
    {
      text: "Operacje",
      value: "actions",
      align: "left"
    }
  ];
  api: Api = sensorApi;
}
